
<div id="app" :class="{ 'nav-collapsed': navCollapsed }">
  <nav-menu v-if="showNavigation" />

  <main :class="{ 'auth': !showNavigation }">
    <nav-header v-if="showNavigation" />

    <section id="content">
      <div
        v-if="navOpen || notificationsOpen"
        class="mask"
        @click="handleOutsideClick"
      />

      <panel-view>
        <router-view />

        <template #panel>
          <side-panel-handler v-if="showSidePanel" />
        </template>
      </panel-view>
    </section>
  </main>

  <notifications-panel v-if="showNavigation" />
  <keyboard-shortcuts />

  <portal-target name="fullscreen" />
  <portal-target name="feedback" />
  <portal-target name="cardfeedback" />
  <portal-target name="modal" />

  <admin-edit-card-modal />
  <admin-edit-post-modal />
  <collection-edit-card-modal />
  <watchlist-alerts-modal />
  <pending-sales-item-edit-modal />
  <add-sale-side-modal />
  <sales-history-item-edit-modal />
  <showcase-share-modal />
</div>
